/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'../../../lib/@waca/dashboard-common/dist/api/PropertiesProviderAPI',
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../app/nls/StringResources'
], function(_, PropertiesProviderAPI, APIFactory, stringResources) {

	class AlignPropertiesProvider {

		constructor(options) {
			this._features = options.features;
			this.content = options.content;
			this.dashboardApi = options.dashboardAPI;
			this._api = APIFactory.createAPI(this, [PropertiesProviderAPI]);

			// register self as a properties provider contributing align properties
			this.content.getFeature('Properties').registerProvider(this.getAPI());
			const featureChecker = this.dashboardApi && this.dashboardApi.getGlassCoreSvc('.FeatureChecker');
			this.isPropertiesV2Enabled = featureChecker && featureChecker.checkValue('dashboard', 'PropertiesV2', 'enabled');
		}

		getAPI() {
			return this._api;
		}

		destroy() {
			this.dashboardApi = null;
		}

		getPropertyLayoutList(){
			let sectionId;
			if (this.isPropertiesV2Enabled) {
				sectionId = 'positionAndStyle';
				return [{
					id: sectionId,
					type: 'Section',
					label: stringResources.get('sectionName_positionAndStyle'),
					position: 1
				},
				...this.getPropertyLayoutControlList('positionAndStyle')];
			} else {
				sectionId = 'layout';
				return [{
					id: 'general',
					type: 'Group',
					label: stringResources.get('tabName_general')
				}, {
					id: sectionId,
					type: 'Section',
					label: stringResources.get('sectionName_layout'),
					position: 2
				},
				...this.getPropertyLayoutControlList('general.layout')];
			}
		}

		getPropertyList() {
			return [];
		}

		reset() { }

		getPropertyLayoutControlList(sectionId) {
			const icons = this._features['Dashboard.Icons'];
			const selectedContentList = this.dashboardApi.getCanvas().getSelectedContentList();
			const shouldDisableDistribution = selectedContentList.length <= 2;
			const alignAction = this.dashboardApi.getFeature('alignAction');

			const alignLayout = {
				id: 'alignWidget',
				editor: {
					sectionId: sectionId,
					readOnly: selectedContentList.length <= 1,
					uiControl: {
						type: 'IconPicker',
						label: stringResources.get('toolbarActionAlign'),
						items: [{
							name: 'left',
							label: stringResources.get('alignWidgetLeft'),
							value: icons.getIcon('align-left').id
						}, {
							name: 'center',
							label: stringResources.get('alignWidgetCenter'),
							value: icons.getIcon('align-horizontally').id
						}, {
							name: 'right',
							label: stringResources.get('alignWidgetRight'),
							value: icons.getIcon('align-right').id
						}, {
							name: 'top',
							label: stringResources.get('alignWidgetTop'),
							value: icons.getIcon('align-top').id
						}, {
							name: 'middle',
							label: stringResources.get('alignWidgetMiddle'),
							value: icons.getIcon('align-vertically').id
						}, {
							name: 'bottom',
							label: stringResources.get('alignWidgetBottom'),
							value: icons.getIcon('align-bottom').id
						}, {
							name: 'horizDistrib',
							label: stringResources.get('distributeWidgetsHoriz'),
							value: icons.getIcon('distribute-horizontal').id,
							disabled: shouldDisableDistribution
						}, {
							name: 'vertDistrib',
							label: stringResources.get('distributeWidgetsVertical'),
							value: icons.getIcon('distribute-vertical').id,
							disabled: shouldDisableDistribution
						}]
					}
				}
			};

			if (this.isPropertiesV2Enabled) {
				alignLayout.editor.position = 4;
				alignLayout.editor.uiControl.onChange = (selection) => {
					alignAction.applyAction(selection.map(entry => {
						return {
							...entry,
							layoutIds: selectedContentList.map(content => content.getId())
						};
					}));
				};
			} else {
				alignLayout.editor.position = 1;
				alignLayout.editor.uiControl.onChange = (name, selection) => {
					alignAction.applyAction(_.map(selection, (entry) => {
						return _.extend(entry, {
							layoutIds: _.map(selectedContentList, content => content.getId())
						});
					}));
				};
			}

			return [
				alignLayout
			];
		}
	}

	return AlignPropertiesProvider;

});